import React from 'react';
const rows = [['Hours every week building practices from scratch', 'Pick the plan, print it, go'], ['Improvised practices with no real order', '43 practices, sequenced across the season'], ['Players standing in line waiting for a rep', 'Stations so everyone is working'], ['“What are we running today?” in the parking lot', 'The 4-Block plan already on your clipboard'], ['Guessing what fits your team’s age', 'Three levels: 6U–8U, 10U–12U, HS & rec']];
export function CostOfInaction() {
  return <section className="w-full bg-navy-deep" data-id="element-82" data-mp="38wk0utontwcf">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-83" data-mp="38v8v4obnmeio">
        <h2 className="text-center font-display font-bold uppercase text-white text-4xl sm:text-5xl" data-id="element-84" data-mp="3dpmut2xcn7t5">
          What another improvised season costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-navy-line" data-id="element-85" data-mp="3nn1bn3n6pylz">
          <div className="grid grid-cols-2 text-center" data-id="element-86" data-mp="3slm42gw73dzv">
            <div className="border-r border-navy-line bg-crimson px-3 py-3 font-display text-lg uppercase tracking-wide text-white sm:text-xl" data-id="element-87" data-mp="3sm43fme5m8c0">
              So no
            </div>
            <div className="bg-green px-3 py-3 font-display text-lg uppercase tracking-wide text-white sm:text-xl" data-id="element-88" data-mp="39glk073l37a3">
              So yes
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-navy-line text-[12.5px] sm:text-sm" data-id="element-89" data-mp="30i9jndcx0v4g">
              <div className="border-r border-navy-line px-3.5 py-3.5 text-white/60 line-through decoration-crimson/60" data-id="element-90" data-mp="3s84m8bpsahb2">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-medium text-white" data-id="element-91" data-mp="3nfbjtuhsfl25">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}